import PortalIdParser from 'PortalIdParser';
const portalId = PortalIdParser.get();
export const getPaymentsEnrollmentEmbedUrl = () => `/payments-enrollment-embed-ui/${portalId}`;
export const URL_LOAD_LOCATION = 'URL_LOAD';